import type { ReactNode } from 'react'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import { makeStyles } from '@mui/styles'
import type { Theme } from '@mui/material/styles'
import BrLine from 'src/components/js_elements/BrLine'

export const useHomeStyles = makeStyles((theme: Theme) => ({
  container: { paddingTop: theme.spacing(4), '& > hr': { marginTop: theme.spacing(6), marginBottom: theme.spacing(6) } },
  homeTextTitle: {},
  homeText: {},
}))
export interface TextContent {
  title: ReactNode
  subtitle?: ReactNode
  paragraphs: ReactNode[]
}
export const HomeText = ({ title, subtitle, paragraphs }: TextContent) => {
  const classes = useHomeStyles()
  return <>
    <Typography className={classes.homeTextTitle} component='h1' variant='h4' color='inherit' gutterBottom><BrLine>{title}</BrLine></Typography>
    {subtitle && <Typography className={classes.homeTextTitle} component='h2' variant='h5' color='inherit' gutterBottom><BrLine>{subtitle}</BrLine></Typography>}
    {paragraphs.map((paragraph, index) => <Typography key={index} className={classes.homeText} component='p' variant='body2' color='inherit' paragraph>{paragraph}</Typography>)}
  </>
}

/** Templates own copy, imagery and curated keys; layout and rendering are shared. */
export const TextHome = (props: TextContent) => {
  const classes = useHomeStyles()
  return <Container maxWidth='lg' className={classes.container}><HomeText {...props} /></Container>
}

